import ImagesIconsCountriesAESvg from '@/public/images/icons/countries/AE.svg';
import ImagesIconsCountriesATSvg from '@/public/images/icons/countries/AT.svg';
import ImagesIconsCountriesAUSvg from '@/public/images/icons/countries/AU.svg';
import ImagesIconsCountriesBESvg from '@/public/images/icons/countries/BE.svg';
import ImagesIconsCountriesBGSvg from '@/public/images/icons/countries/BG.svg';
import ImagesIconsCountriesBRSvg from '@/public/images/icons/countries/BR.svg';
import ImagesIconsCountriesCASvg from '@/public/images/icons/countries/CA.svg';
import ImagesIconsCountriesCHSvg from '@/public/images/icons/countries/CH.svg';
import ImagesIconsCountriesCYSvg from '@/public/images/icons/countries/CY.svg';
import ImagesIconsCountriesCZSvg from '@/public/images/icons/countries/CZ.svg';
import ImagesIconsCountriesDESvg from '@/public/images/icons/countries/DE.svg';
import ImagesIconsCountriesDKSvg from '@/public/images/icons/countries/DK.svg';
import ImagesIconsCountriesEESvg from '@/public/images/icons/countries/EE.svg';
import ImagesIconsCountriesESSvg from '@/public/images/icons/countries/ES.svg';
import ImagesIconsCountriesFISvg from '@/public/images/icons/countries/FI.svg';
import ImagesIconsCountriesFRSvg from '@/public/images/icons/countries/FR.svg';
import ImagesIconsCountriesGBSvg from '@/public/images/icons/countries/GB.svg';
import ImagesIconsCountriesGISvg from '@/public/images/icons/countries/GI.svg';
import ImagesIconsCountriesGRSvg from '@/public/images/icons/countries/GR.svg';
import ImagesIconsCountriesHKSvg from '@/public/images/icons/countries/HK.svg';
import ImagesIconsCountriesHRSvg from '@/public/images/icons/countries/HR.svg';
import ImagesIconsCountriesHUSvg from '@/public/images/icons/countries/HU.svg';
import ImagesIconsCountriesIDSvg from '@/public/images/icons/countries/ID.svg';
import ImagesIconsCountriesIESvg from '@/public/images/icons/countries/IE.svg';
import ImagesIconsCountriesINSvg from '@/public/images/icons/countries/IN.svg';
import ImagesIconsCountriesITSvg from '@/public/images/icons/countries/IT.svg';
import ImagesIconsCountriesJPSvg from '@/public/images/icons/countries/JP.svg';
import ImagesIconsCountriesLISvg from '@/public/images/icons/countries/LI.svg';
import ImagesIconsCountriesLTSvg from '@/public/images/icons/countries/LT.svg';
import ImagesIconsCountriesLUSvg from '@/public/images/icons/countries/LU.svg';
import ImagesIconsCountriesLVSvg from '@/public/images/icons/countries/LV.svg';
import ImagesIconsCountriesMTSvg from '@/public/images/icons/countries/MT.svg';
import ImagesIconsCountriesMXSvg from '@/public/images/icons/countries/MX.svg';
import ImagesIconsCountriesMYSvg from '@/public/images/icons/countries/MY.svg';
import ImagesIconsCountriesNLSvg from '@/public/images/icons/countries/NL.svg';
import ImagesIconsCountriesNOSvg from '@/public/images/icons/countries/NO.svg';
import ImagesIconsCountriesNZSvg from '@/public/images/icons/countries/NZ.svg';
import ImagesIconsCountriesPLSvg from '@/public/images/icons/countries/PL.svg';
import ImagesIconsCountriesPTSvg from '@/public/images/icons/countries/PT.svg';
import ImagesIconsCountriesROSvg from '@/public/images/icons/countries/RO.svg';
import ImagesIconsCountriesSESvg from '@/public/images/icons/countries/SE.svg';
import ImagesIconsCountriesSGSvg from '@/public/images/icons/countries/SG.svg';
import ImagesIconsCountriesSISvg from '@/public/images/icons/countries/SI.svg';
import ImagesIconsCountriesSKSvg from '@/public/images/icons/countries/SK.svg';
import ImagesIconsCountriesTHSvg from '@/public/images/icons/countries/TH.svg';
import ImagesIconsCountriesUSSvg from '@/public/images/icons/countries/US.svg';

export {
  ImagesIconsCountriesAESvg,
  ImagesIconsCountriesATSvg,
  ImagesIconsCountriesAUSvg,
  ImagesIconsCountriesBESvg,
  ImagesIconsCountriesBGSvg,
  ImagesIconsCountriesBRSvg,
  ImagesIconsCountriesCASvg,
  ImagesIconsCountriesCHSvg,
  ImagesIconsCountriesCYSvg,
  ImagesIconsCountriesCZSvg,
  ImagesIconsCountriesDESvg,
  ImagesIconsCountriesDKSvg,
  ImagesIconsCountriesEESvg,
  ImagesIconsCountriesESSvg,
  ImagesIconsCountriesFISvg,
  ImagesIconsCountriesFRSvg,
  ImagesIconsCountriesGBSvg,
  ImagesIconsCountriesGISvg,
  ImagesIconsCountriesGRSvg,
  ImagesIconsCountriesHKSvg,
  ImagesIconsCountriesHRSvg,
  ImagesIconsCountriesHUSvg,
  ImagesIconsCountriesIDSvg,
  ImagesIconsCountriesIESvg,
  ImagesIconsCountriesINSvg,
  ImagesIconsCountriesITSvg,
  ImagesIconsCountriesJPSvg,
  ImagesIconsCountriesLISvg,
  ImagesIconsCountriesLTSvg,
  ImagesIconsCountriesLUSvg,
  ImagesIconsCountriesLVSvg,
  ImagesIconsCountriesMTSvg,
  ImagesIconsCountriesMXSvg,
  ImagesIconsCountriesMYSvg,
  ImagesIconsCountriesNLSvg,
  ImagesIconsCountriesNOSvg,
  ImagesIconsCountriesNZSvg,
  ImagesIconsCountriesPLSvg,
  ImagesIconsCountriesPTSvg,
  ImagesIconsCountriesROSvg,
  ImagesIconsCountriesSESvg,
  ImagesIconsCountriesSGSvg,
  ImagesIconsCountriesSISvg,
  ImagesIconsCountriesSKSvg,
  ImagesIconsCountriesTHSvg,
  ImagesIconsCountriesUSSvg,
};
